import { NextRouter } from 'next/router';
import { useEffect } from 'react';
import yn from 'yn';
import { useIsAppView } from './useIsAppView';
import { useDeviceOs } from './useDeviceOs';
import { Auth0UserInfo } from '@lib/auth0/utils';

type UseLoggedOutRedirectParams = {
  router: NextRouter;
  user?: Auth0UserInfo;
  redirectPath: string;
  userIsLoading: boolean;
  mobileOnly?: boolean;
};

const useLoggedOutRedirect = ({
  router,
  user,
  redirectPath,
  userIsLoading,
  mobileOnly = false
}: UseLoggedOutRedirectParams) => {
  const { isAppView, isLoading: isAppViewLoading } = useIsAppView();
  const { isMobile } = useDeviceOs();

  const isRedirecting =
    !yn(process.env.NEXT_PUBLIC_IS_TEST) &&
    !userIsLoading &&
    !isAppViewLoading &&
    !user &&
    !isAppView &&
    (!mobileOnly || isMobile);

  useEffect(() => {
    if (!isRedirecting) return;

    const { via } = router.query;
    // Preserve the page the user was trying to reach so the funnel's
    // "Already a member? Log in" link can return them to it after login.
    const searchParameters = new URLSearchParams({ returnTo: router.asPath });
    const viaValue = Array.isArray(via) ? via[0] : via;
    if (viaValue) searchParameters.set('via', viaValue);
    router.push(`/${redirectPath}?${searchParameters.toString()}`);
  }, [isRedirecting, router, redirectPath]);

  return { isRedirecting };
};

export default useLoggedOutRedirect;
